import { render } from "./APropos.vue?vue&type=template&id=3e062a88&scoped=true"
import script from "./APropos.vue?vue&type=script&lang=js"
export * from "./APropos.vue?vue&type=script&lang=js"

import "./APropos.vue?vue&type=style&index=0&id=3e062a88&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e062a88"]])

export default __exports__